import classNames from 'classnames';
import { XCircle } from 'react-feather';
import { GripDots } from '../../../../CustomIcon';
var classes = {
    base: 'cursor-pointer flex items-center gap-2 text-xs rounded-full px-3 py-2 transition-all',
    unSelected: 'text-brand-01 bg-secondary-01 bg-opacity-10 md:hover:opacity-60',
    selected: 'bg-brand-01 text-white md:hover:opacity-60',
    sortable: '!cursor-grab',
    disabled: 'bg-gray-100 text-gray-400 pointer-events-none',
};
var MultiSelectFullPill = function (_a) {
    var item = _a.item, onClick = _a.onClick, selected = _a.selected, _b = _a.sortable, sortable = _b === void 0 ? false : _b, disabled = _a.disabled, className = _a.className;
    return (<div className={classNames(classes.base, !selected && !disabled && classes.unSelected, selected && classes.selected, disabled && classes.disabled, sortable && classes.sortable, className)} onClick={onClick}>
      {sortable && (<GripDots className="flex-none" size={16} fill={selected ? '#FFFFFF' : '#000000'}/>)}
      {item.title}
      {selected && <XCircle className="flex-none cursor-pointer" size={12}/>}
    </div>);
};
export default MultiSelectFullPill;
